// Readable labels for the backend's send_methods codes shown in the "Sent via ..." badge.
// Most codes read fine lowercased ("EMAIL" -> "email"); these are internal names that don't.
const SEND_METHOD_LABELS = {
  EMAIL_WEB_FORM: 'website form',   // contact-form submission BCC'd to an intake address
  EMAIL_TEAM_REPLY: 'email',        // team reply from their inbox to a website inquiry
};

export function sendMethodLabel(method) {
  const code = String(method || '');
  return SEND_METHOD_LABELS[code.toUpperCase()] || code.toLowerCase().replace(/_/g, ' ');
}

export function sendMethodsLabel(sendMethods) {
  // Dropping "automated" from "automated in-app" left "Sent via  in-app" (two spaces).
  return sendMethods.map(sendMethodLabel).join(', ').replace('automated', '').replace(/\s+/g, ' ').trim();
}
